import { render, staticRenderFns } from "./ecosystem-brand-card.vue?vue&type=template&id=a8ec57fc"
import script from "./ecosystem-brand-card.vue?vue&type=script&lang=js"
export * from "./ecosystem-brand-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports